var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCurrency = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.11 1a.75.75 0 0 1 .75.75v1.49h2.05a.75.75 0 0 1 0 1.5H8.86v2.42h.65a2.71 2.71 0 0 1 0 5.42h-.65v1.49a.75.75 0 0 1-1.5 0v-1.49H4.75a.75.75 0 0 1 0-1.5h2.61V8.66h-.65a2.71 2.71 0 0 1 0-5.42h.65V1.75A.75.75 0 0 1 8.11 1zm.75 10.08h.65a1.21 1.21 0 0 0 0-2.42h-.65v2.42zM6.71 4.74a1.21 1.21 0 0 0 0 2.42h.65V4.74h-.65z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCurrency);
export default ForwardRef;